import { render, staticRenderFns } from "./BusinessPlanView.vue?vue&type=template&id=03878fc7&scoped=true&"
import script from "./BusinessPlanView.vue?vue&type=script&lang=js&"
export * from "./BusinessPlanView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPlanView.vue?vue&type=style&index=0&id=03878fc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03878fc7",
  null
  
)

export default component.exports